import { render } from "./ChatMenu.vue?vue&type=template&id=4f775a24"
import script from "./ChatMenu.vue?vue&type=script&lang=js"
export * from "./ChatMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/chat/ChatMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f775a24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f775a24', __exports__)) {
    api.reload('4f775a24', __exports__)
  }
  
  module.hot.accept("./ChatMenu.vue?vue&type=template&id=4f775a24", () => {
    api.rerender('4f775a24', render)
  })

}


export default __exports__